import { useTranslation } from "@i18n";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import { getImageUrl } from "@Utils";

interface SubscriptionWarningProps {
  message?: React.ReactNode;
  description?: React.ReactNode;
  showUpgradeButton?: boolean;
  showFooterMessage?: boolean;
}

function SubscriptionWarning({
  message,
  description,
  showUpgradeButton,
  showFooterMessage,
}: Readonly<SubscriptionWarningProps>) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex w-full flex-col items-center justify-around">
        <img className="" src={`${getImageUrl()}/logoAndText.png`} />
        <div className="flex w-full flex-col items-center gap-16">
          <div className="flex flex-col items-center gap-14">
            {/* The desktop -me-37.5 nudges this 531px illustration right of centre; on a phone that pushed it off
                the screen, so phones centre it and cap it at the column width. */}
            <img
              className="w-fit -me-37.5 max-sm:me-0 max-sm:max-w-full max-sm:h-auto"
              src={`${getImageUrl()}/subscriptionWarning.svg`}
            />
            <div className="flex flex-col gap-3 max-sm:px-4 max-sm:text-center">
              <span className="text-4xl font-bold">{message}</span>
              <span className="text-2xl font-bold">{description}</span>
            </div>
          </div>
          {showUpgradeButton && (
            <div className="flex">
              <ButtonComponent>{t("Upgrade")}</ButtonComponent>
            </div>
          )}
        </div>
        {showFooterMessage && (
          <div className="text-center">
            {t(
              "Need support with increasing/decreasing your seats or have any questions related to pricing or billing? Raise a support ticket here.",
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default SubscriptionWarning;
